module.exports = __webpack_public_path__ + "img/student_help_certificates_notifications.dbe8ae11.jpg";